import ConfirmModal from "PFComponents/confirm/confirm_modal";
import Toggle from "PFComponents/toggle/toggle";
import { getProfileName } from "PFCore/helpers/profile";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { toggleAdmin } from "PFCore/services/admin/users/toggle_admin";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

const AdminAction = ({ user, refetchUsers }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.list.actions" });
  const { data: currentProfile } = useCurrentProfile();

  const [modalQuestion, setModalQuestion] = useState("");

  const isAdmin = user.roles && user.roles.indexOf("admin") >= 0;

  const handleAdminChange = useCallback(() => {
    const questionKey = isAdmin ? "adminRemoveConfirm" : "adminAddConfirm";
    const question = t(questionKey, { name: getProfileName(user) });

    setModalQuestion(question);
  }, [user, isAdmin, t]);

  const handleConfirmOK = () => toggleAdmin(user.id, !isAdmin).then(refetchUsers);

  if (currentProfile.id === user.id) {
    return null; // admin cannot degrade themself
  }

  return (
    <>
      <Toggle
        qaId={`AdminActionButton.admin.${isAdmin ? "isAdmin" : "isNotAdmin"}`}
        onChange={handleAdminChange}
        checked={isAdmin}
        inline
      />
      {modalQuestion && (
        <ConfirmModal handleOK={handleConfirmOK} handleClose={() => setModalQuestion("")}>
          {modalQuestion}
        </ConfirmModal>
      )}
    </>
  );
};

AdminAction.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    roles: PropTypes.array
  }),

  refetchUsers: PropTypes.func
};

export default AdminAction;
